// extracted by mini-css-extract-plugin
module.exports = {"list__data":"SimpleList-hashed__list__data__EAoxk","list__dataLabel":"SimpleList-hashed__list__dataLabel__3We8_"};